<div [class]="status.class">
  <i [class]="status.icon"></i>
  <div>{{ status.text }}</div>
</div>
